import { ApiUtil as api } from '@/utils/api.util.js'

export class OrderOperationService {
  static URL = process.env.API_URL + process.env.API_VER
  static RESOURCE = '/order-operations/'

  static all (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams)
  }

  static find (id, queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + id, queryParams)
  }

  static create (queryParams = {}) {
    return api.post(this.URL + this.RESOURCE, queryParams)
  }
  static createOperation (queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'create/', queryParams)
  }
  static update (id, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + id, queryParams)
  }

  static complete (id, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/complete', queryParams)
  }

  static updateStatus (id, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/status', queryParams)
  }

  static listComments (id, queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + id + '/comments', queryParams)
  }

  static createComment (id, queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + id + '/comments', queryParams)
  }

  static approveComment (id, commentId, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/comments/' + commentId, queryParams)
  }

  static setOwnerFirmid (queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + 'set-owner-firm', queryParams)
  }

  static listLogs (id, queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + id + '/logs', queryParams)
  }
  
  static hybridCreate (queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'hybrid/create', queryParams)
  }
  static createMultipleClaimLine (id, queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'create/multiple-claimlines/' + id, queryParams)
  }
  static createNewComment (id, queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'create/comment/' + id, queryParams)
  }


}



// WEBPACK FOOTER //
// ./src/services/orderOperation.service.js